import useTranslation from '@app/hooks/use-translation';
import { AnalyticProjectExportSettings } from '@app/interfaces/analytics';
import { formBaseButtonBlockStyles } from '@app/styles/base-styles';
import { Button, Toggle } from '@ui';
import React from 'react';
type ExportFormFeaturePropsType = {
  changeExportSettings: React.Dispatch<
    React.SetStateAction<Omit<AnalyticProjectExportSettings, 'project_id'>>
  >;
  exportSettings: Omit<AnalyticProjectExportSettings, 'project_id'>;
  handleExportAPSettings(): void;
  onClose(): void;
};
const ExportFormFeature: React.FC<ExportFormFeaturePropsType> = ({
  changeExportSettings,
  exportSettings,
  handleExportAPSettings,
  onClose,
}) => {
  const { t } = useTranslation('components.importExportAp');

  return (
    <div className="relative py-[20px]">
      <div className="flex flex-col gap-[20px] items-center">
        <div className="grid grid-cols-[200px_1fr]">
          <span>{t('preset_settings')}</span>
          <Toggle
            checked={exportSettings.include_preset}
            onChecked={(val) => {
              changeExportSettings((prev) => ({ ...prev, include_preset: val }));
            }}
          />
        </div>
        <div className="grid grid-cols-[200px_1fr]">
          <span>{t('metrics_settings')}</span>
          <Toggle
            checked={exportSettings.include_metrics}
            onChecked={(val) => {
              changeExportSettings((prev) => ({ ...prev, include_metrics: val }));
            }}
          />
        </div>
        <div className="grid grid-cols-[200px_1fr]">
          <span>{t('reports_settings')}</span>
          <Toggle
            checked={exportSettings.include_reports}
            onChecked={(val) => {
              changeExportSettings((prev) => ({ ...prev, include_reports: val }));
            }}
          />
        </div>
      </div>
      <div className={formBaseButtonBlockStyles}>
        <Button
          onClick={() => {
            handleExportAPSettings();
            onClose();
          }}
          label={t('download')}
        />
        <Button onClick={onClose} fill="linked" label={t('cancel')} />
      </div>
    </div>
  );
};

export default ExportFormFeature;
